/**
 * @file コンポーネント：フル動画ページタイムライントピック DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { TimelineTopicComment } from "~/src/components/projects/Video/TimelineTopicComment";

// スタイル設定読み込み
import {
    StyledTopicButton,
    StyledTopicComment,
    StyledTopicHeader,
    StyledTopicHeaderTime,
    StyledTopicHeaderTitle,
    StyledTopicHeaderTitleText,
    StyledTopicToggleButton,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <>
            {/* トピック見出し */}
            <StyledTopicHeader>
                <StyledTopicButton
                    onClick={() => {
                        props.fnOnClickButton(props.itemTime, props.itemText);
                    }}
                >
                    <StyledTopicHeaderTime>
                        {props.itemTime}
                    </StyledTopicHeaderTime>
                    {/* サムネイル */}
                    {props.thumbnail && (
                        <img
                            src={props.thumbnail.src}
                            style={props.thumbnail.style}
                            alt="thumbnail"
                        />
                    )}
                    <StyledTopicHeaderTitle>
                        <StyledTopicHeaderTitleText>
                            {props.itemText}
                        </StyledTopicHeaderTitleText>
                    </StyledTopicHeaderTitle>
                </StyledTopicButton>

                <StyledTopicToggleButton
                    onClick={(e) => {
                        props.setIsOpen(!props.isOpen);
                        e.stopPropagation();
                    }}
                >
                    {props.isOpen === true ? (
                        <i className="fas fa-chevron-up"></i>
                    ) : (
                        <i className="fas fa-chevron-down"></i>
                    )}
                </StyledTopicToggleButton>
            </StyledTopicHeader>

            {/* トピックコメントリスト */}
            {props.listTopic
                // 未ログイン時は最大2件までに制限
                .filter((_, index) => {
                    if (!window.dataUser.isLogin) {
                        return index < 2; // 0,1 のみ表示
                    }
                    return true; // ログイン時は全件
                })
                .map((topic, id) => {
                    const isSecondAndNotLogin = !window.dataUser.isLogin && id === 1;
                    const isLockedLast = !window.dataUser.isLogin && id === 1; // 2件目
                    const isLast = props.listTopic.length === id + 1;
                    return (
                        <StyledTopicComment
                            className={
                                (props.isOpen ? "is-open" : "is-close") +
                                (isLast && !isLockedLast ? " is-last" : "") +
                                (isLockedLast ? " is-locked-last" : "")
                            }
                            key={"topic-" + id}
                        >
                            <StyledTopicButton
                                onClick={() =>
                                    props.fnOnClickButton(
                                        topic.time,
                                        isSecondAndNotLogin
                                            ? localized["Label.LoginToSeeFullTimelineTopic"]
                                            : topic.text
                                    )
                                }
                            >
                                <TimelineTopicComment
                                    mainSurgeonId={props.mainSurgeonId}
                                    text={
                                        isSecondAndNotLogin
                                            ? localized["Label.LoginToSeeFullTimelineTopic"]
                                            : topic.text
                                    }
                                    time={topic.time}
                                    userId={topic.userId}
                                    userInitial={topic.userInitial}
                                    userName={topic.userName}
                                />
                            </StyledTopicButton>
                        </StyledTopicComment>
                    );
                })}
        </>
    );
};
